
import { useEffect } from "react";
import { Bell, LogOut } from "lucide-react";
import Logo from "../../../Images/Packky Logo Blue.svg";
import ConfirmLogoutModal from "../../Utils/./ConfirmLogoutModal";
import useDriverTeams from "../../../Sevices/Driver Api/useDriverTeams";

export default function Header() {

 const { fetchDriverTeams } = useDriverTeams();

useEffect(() => {
  fetchDriverTeams();
}, []);

  return (
    <div className="bg-sky-100 text-white w-full">
      <div className="flex items-center justify-between py-2 px-3">
        {/* CENTER: Logo */}
        <img src={Logo} alt="Logo" className="h-7 mx-auto" />

        {/* RIGHT: Actions */}
        <div className="space-x-3 flex items-center">

          <Bell size={18} className="text-blue-600 cursor-pointer" />

          <ConfirmLogoutModal
            trigger={<LogOut size={18} className="text-blue-600 cursor-pointer" />}
          />

        </div>
      </div>
    </div>
  );
}
